<template>
    <section class="gmp-section gmp-mb-l">
        <div class="two-column-tout">
            <div class="h-c-page">

                <div class="h-c-grid">
                    <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6
            h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                        <h3 class="h-c-headline h-c-headline--one">
                            保障质量一致性和战略合作
                        </h3>
                        <div class="h-u-mb-std two-column-tout__description">
<!--                            <p>门店 库房 采购部门岗位小程序.</p>-->
                            <p class="">
                                单品供货商在“时鲜管理”中的作用至关重要，它们通过专业化供应、提高采购效率、保障质量一致性和战略合作，
                                为企业提供了巨大的价值和竞争优势
                            </p>
                        </div>
                        <a  @click="toEnterprisePage('/market/goods/GOODS_Special','/market/goods/GOODS_Special')"
                            class="h-c-link h-c-link--internal gmp-link">
                            查看详细
                        </a>
                    </div>

                    <div class="h-c-grid__col
          h-c-grid__col-l--6  h-c-grid__col--align-middle">
                        <div class="two-column-tout__image text-center">
                            <picture>
                                <img src="@/assets/img/right.png" alt="" class="gmp-no-grab ">
                            </picture>
                        </div>
                    </div>

                </div>
            </div>


        </div>

    </section>
</template>

<script>
    export default {
        name: "GOODS_twoTout",
        methods:{

            toEnterprisePage(data, url) {
                this.$router.push(data)
                this.$('body').removeClass('h-is-showing-drawer');
                var lis = this.$('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < lis.length; i++) {
                    var toWhere = this.$(lis[i]).attr('to-where');
                    console.log("toWhere===" + toWhere);
                    if (toWhere === url) {
                        this.$(lis[i]).addClass('h-is-active');
                    } else {
                        this.$(lis[i]).removeClass('h-is-active')
                    }
                }
            },
        }
    }
</script>

<style lang="less">


</style>
